/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Tracks_TitleInputs */

const en_cp_tracks_title = /** @type {(inputs: Cp_Tracks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a track, run the same loop`)
};

const id_cp_tracks_title = /** @type {(inputs: Cp_Tracks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih jalur, jalankan loop yang sama`)
};

/**
* | output |
* | --- |
* | "Pick a track, run the same loop" |
*
* @param {Cp_Tracks_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_tracks_title = /** @type {((inputs?: Cp_Tracks_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Tracks_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_tracks_title(inputs)
	return en_cp_tracks_title(inputs)
});